const getMessagesSucessType = 'GET_MESSAGES_SUCESS_TYPE';
const getApplicationInfoForMessagesSuccessType = 'GET_APP_INFO_FOR_MESSAGES';

export {
  getMessagesSucessType,
  getApplicationInfoForMessagesSuccessType
}